import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { HubConnectionBuilder } from '@microsoft/signalr'
import { useAuth, useToast, useSignalRAction } from 'hooks'
import { useAuthSignalRQuery } from 'services'
import { connectSignalr } from 'features/auth/appSlice'
import { add, markRead } from 'features/bell-notification/notificationSlice'

export const useSignalR = () => {
    const { isAuthenticated } = useAuth()
    const { toaster } = useToast()
    const dispatch = useDispatch()
    const { action } = useSignalRAction()
    const [connection, setConnection] = useState(null)

    const { data: signalRAuth } = useAuthSignalRQuery(isAuthenticated, {
        skip: !isAuthenticated,
    })

    useEffect(() => {
        if (signalRAuth) {
            const newConnection = new HubConnectionBuilder()
                .withUrl(signalRAuth.url, { accessTokenFactory: () => signalRAuth.accessToken })
                .withAutomaticReconnect()
                .build()
            setConnection(newConnection)
        }
    }, [signalRAuth])

    useEffect(() => {
        if (connection) {
            connection
                .start()
                .then(() => {
                    dispatch(connectSignalr())
                    connection.on('MessageReceived', message => {
                        const msg = JSON.parse(message)
                        console.log(msg)
                        msg.messageBody &&
                            toaster(msg.messageBody, msg.messageType, {
                                onClose: () => {
                                    if (msg.isBellNotify) dispatch(markRead([msg.id]))
                                },
                            })
                        if (msg.isBellNotify) {
                            dispatch(add(msg))
                        }
                        msg.action && action(msg.action, msg.meta)
                    })
                })
                .catch(() => dispatch(connectSignalr()))
        }
        return () => {
            if (connection) connection.stop()
        }
    }, [connection])

    return connection
}
